import { defineStore } from "pinia";
interface LocationInfo {
  lat: String | null;
  lon: String | null;
  address: String;
  locTime: any;
}
interface User {
  empId: String;
  userStatus: Number; // 用户状态； 1：正常， 2：禁用，3：删除
  websiteManage: Number; //  网点主管，1：是，0：否
  emplWebsiteId: String; // 网点id
  emplWebsiteName: String;
  avatar: String | ""; // 头像
  userName: String | ""; // 用户名； 管理后台用户可用来登录
  userId: String;
  defaultWebsiteId: String | ""; // 默认营业网点
  token: String | null;
  userLastLoginTimeUx: Number;
  websiteName: String;
  websiteSm: Number; // 网点sm模式； 1：正常模式， 2：sm模式
  empName: String; // 员工姓名
  userType: Number; // 用户类型；1：管理后台用户
}
export const userAuthStore = defineStore("auth-store", {
  state: (): any => {
    return {
      authToken: null as unknown as String,
      currUserData: null as unknown as User,
      loctionInfo: null as unknown as LocationInfo,
      platform: null as unknown as String,
    };
  },
  getters: {
    userId: (_state) => {},
  },
});
